import React from 'react';
import {Row, Col} from 'antd';
import {DeclaredComponent} from '../DynamicComponent';


export function Grid({rows, children, ...props}) {
  return <div {...props}>

    {rows.map(({cols, ...rowProps}, i) => <Row key={i} {...rowProps}>
      { cols.map(({content, ...colProps}, j) => <Col key={j} {...colProps}><DeclaredComponent declaration={content} /></Col>) }
    </Row>)}

  </div>
}